<template>
  <div v-if="loaded" class="period-tabs mb-3">
    <draggable v-if="!isMobile" handle=".loading-item-handle" v-model="tabs" @end="savePosition">
      <editabel-tab v-for="item in tabs" :key="item.id" :item="item" :count="tabs.length" @update="loadLoadings" />
    </draggable>
    <tabs-mobile v-else :tabs="tabs" @update="loadLoadings" />
    <v-btn 
        @click="onClick"
        :title="$t('base.create_period')"
        :class="['add-period', { full: !tabs || tabs.length === 0 }]">
          <v-icon font-size="1" icon="plus" />
          <span>{{ 'base.add_period' | translate }}</span>
    </v-btn>
    <v-dialog
  v-model="modals.showAddPeriod"
  max-width="335"
>
  <create-period-modal
    @close="modals.showAddPeriod = false"
  />
</v-dialog>

  </div>

</template>

<script>
import api from '@/api'

import adaptationMixin from '@/mixins/adaptation.mixin.js'
import { getFarmPath } from '@/util/app.js'
import { getDateForDatePicker } from '@/util'
import Draggable from 'vuedraggable'
import CreatePeriodModal from './modals/CreatePeriodModal'
import EditabelTab from './EditableTab.vue'
import TabsMobile from './TabsMobile'
import { mapGetters } from 'vuex'
export default {
  name: 'Tabs',

  mixins: [adaptationMixin],

  props: {
    date: String
  },

  components: {
    Draggable,
    EditabelTab,
    TabsMobile,
    CreatePeriodModal
  },

  mounted () {
    this.init()
    this.$store.dispatch('setPeriodsUpdater', this.init)
  },

  data: () => ({
    modals: {
      showAddPeriod: false
    },
    tabs: [],
    loaded: false,
    loadingId: 0
  }),

  methods: {
    async init () {
      if (this.isAuth) {
        // Load periods for schedule..
        // if (this.allowView) {
        await this.loadLoadings()
        // }
        if (!this.hasLoadingInList(this.$route.params.loading_id)) {
          this.loadingId = this.tabs.length ? this.tabs[0].loading : -1
        } else {
          this.loadingId = this.$route.params.loading_id
        }
        const basePath = getFarmPath(null, this.$route)
        const path = `${basePath}/planning?loading=${this.loadingId}&date=${this.plannedOn}`
        this.$router.replace(path)
        this.loaded = true
      }
    },
    async onClick () {
      this.modals.showAddPeriod = true
    },
    hasLoadingInList (id) {
      for (let item of this.tabs) {
        if (item.loading === +id) {
          return true
        }
      }
      return false
    },

    async loadLoadings () {
      const params = {
        planned_on: this.plannedOn,
        farm: this.$route.params.farm_id
      }
      const { data, errors } = await api.schedule.loadings.list(params)
      if (!errors) {
        this.tabs = data
        this.sortTabsByOrdering()
      }
    },

    sortTabsByOrdering () {
      this.tabs = this.tabs.sort((item1, item2) => {
        return item1.ordering - item2.ordering
      })
    },

    savePosition () {
      this.tabs.forEach((element, index) => {
        if (!element.deleted) {
          const data = {
            farm: this.$route.params.farm_id,
            name: element.name,
            ordering: index + 1
          }
          const id = element.loading
          api.loadings.updateById(id, data)
        }
      })
    },

    update (payload) {
      if (this.allowChange) {
        const data = {
          farm: this.tabs[payload.index].farm,
          name: this.tabs[payload.index].name,
          ordering: this.tabs[payload.index].ordering
        }
        api.loadings.updateById(payload.id, data)
      }
    },

    create () {
      this.$router.push('loading/create')
    }
  },

  computed: {
    path () {
      return this.$route.path
    },
    timezone () {
      return this.$store.getters['account/timezone']
    },
    wasPlanningCreated () {
      return this.$store.getters['planning/wasPlanningCreated']
    },
    plannedOn () {
      return (this.date ? this.date : getDateForDatePicker(this.timezone))
    },

    isAuth () {
      return this.$store.getters['account/isAuth']
    },

    needToUpdate () {
      return this.$store.getters.ntuPeriods
    },

    allowView () {
      return this.hasPermission('schedule_loading', 'view')
    },

    allowChange () {
      return this.hasPermission('loading', 'change')
    },
    ...mapGetters('planning', [
      'getPlanningData'
    ]),
    planningData () {
      return this.getPlanningData
    },
  },

  watch: {
    path (value, prev) {
      if (prev.includes('loading') || prev.includes('create')) {
        this.init()
      }
    },

    date () {
      this.init()
    },
    async planningData (newVal) {
      const date = getDateForDatePicker(this.timezone)
      const params = {
        planned_on: date,
        farm: this.$route.params.farm_id
      }
      const { data, errors } = await api.schedule.loadings.list(params)
      if (!errors) {
        const basePath = getFarmPath(null, this.$route)
        const path = `${basePath}/planning?loading=${data[0].loading}&date=${date}`
        this.$router.replace(path)
      }
    },
    async wasPlanningCreated (newVal) {
      if (newVal) {
        await this.loadLoadings()
        this.$store.dispatch('planning/clearPlanningCreated')
      }
    }
  }
}
</script>

<style scoped>
.add-period span {
  display: none;
  margin-left: 1.3rem;
  white-space: nowrap;
}
.add-period {
  width: 4rem;
  height: 4rem;
  min-width: 4rem;

}
.add-period.full span {
  display: block;
}
.add-period.full {
  min-width: 20.4rem;
}
.period-tabs {
  display: flex;
  gap: 2rem;
  justify-content: space-between;
}

.period-tabs>div {
  width: 100%;
  display: flex;
  align-items: center;
  /* flex-wrap: wrap; */
  gap: 2rem;
}
</style>
